<!-- Energy Process Flow Details -->
<mat-expansion-panel
  class="md-expansion-demo-width"
  #myEnergyPanel
  expanded="false"
  [disabled]="energyUtility"
>
  <mat-expansion-panel-header>
    <mat-panel-title>
      <div class="col-md-6"><h6>Energy Process Flow Details</h6></div>
      <div class="col-md-6" *ngIf="siteId !== '' && siteId !== 'default'">
        <h6>Site Id: {{ siteId }}</h6>
      </div>
    </mat-panel-title>
  </mat-expansion-panel-header>

  <form [formGroup]="formdata" #formDirective="ngForm" novalidate>
    <div class="row">
      <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">
        <div class="row">
          <div class="col-lg-6">
            <mat-label class="label-input"
              >Create New Process <span class="iep-required">*</span></mat-label
            >
          </div>
          <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">
            <mat-form-field>
              <mat-select
                [(ngModel)]="createNewProcess"
                (selectionChange)="onCreateNewProcessSelectionChanged()"
                formControlName="createNewProcessCtr"
              >
                <mat-option value="">-- Yes / No --</mat-option>
                <mat-option value="true">Yes</mat-option>
                <mat-option value="false">No</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
      </div>

      <!-- column Process -->
      <div
        class="col-xs-6 col-sm-6 col-md-6 col-lg-6"
        *ngIf="createNewProcess === 'false'"
      >
        <div class="row">
          <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">
            <mat-label class="label-input">Process</mat-label>
          </div>
          <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">
            <mat-form-field>
              <mat-select
                [(ngModel)]="process.processId"
                formControlName="processCtr"
              >
                <mat-option value="">-- choose Process --</mat-option>
                <mat-option
                  *ngFor="let processItem of processes"
                  value="{{ processItem.processId }}"
                  >{{ processItem.name }}</mat-option
                >
              </mat-select>
            </mat-form-field>
          </div>
        </div>
      </div>
      <div
        class="col-xs-6 col-sm-6 col-md-6 col-lg-6"
        *ngIf="createNewProcess === 'true'"
      >
        <div class="row">
          <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">
            <mat-label class="label-input"
              >Process Name<span class="iep-required">*</span></mat-label
            >
          </div>
          <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">
            <mat-form-field>
              <input
                matInput
                formControlName="processnameCtr"
                id="processName"
                [(ngModel)]="process.processName"
                (focusout)="onProcessNameFocusOut()"
                required
              />
              <mat-error
                *ngIf="formdata.get('processnameCtr').hasError('required')"
                >This field is required.</mat-error
              >
              <mat-error
                *ngIf="formdata.get('processnameCtr').hasError('duplicated')"
                >Duplicated Process Name.</mat-error
              >
              <mat-error
                *ngIf="formdata.get('processnameCtr').hasError('maxlength')"
              >
                Please provide name up to 50 Characters.
              </mat-error>
              <mat-error
                *ngIf="formdata.get('processnameCtr').hasError('pattern')"
              >
                Only (& . - _ / : ,) special symbol allowed.
              </mat-error>
              <mat-error
                *ngIf="formdata.get('processnameCtr').hasError('whitespace')"
                >Please enter valid text.</mat-error
              >
            </mat-form-field>
          </div>
        </div>
      </div>
    </div>

    <fieldset *ngIf="createNewProcess === 'true'">
      <legend></legend>
      <div class="row">
        <div
          class="col-xs-6 col-sm-6 col-md-6 col-lg-6"
          [ngClass]="{
            'has-error':
              formdata.get('inputconstraintsCtr').hasError('maxlength') === true
          }"
        >
          <div class="row">
            <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">
              <mat-label class="label-input">Input Constraints</mat-label>
            </div>
            <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">
              <mat-form-field>
                <input
                  matInput
                  formControlName="inputconstraintsCtr"
                  placeholder=""
                  [(ngModel)]="process.inputConstraint"
                />
                <mat-error
                  *ngIf="
                    formdata.get('inputconstraintsCtr').hasError('maxlength')
                  "
                  class="help-block"
                  >inputConstraints is too long.</mat-error
                >
                <mat-error
                  *ngIf="
                    formdata.get('inputconstraintsCtr').hasError('whitespace')
                  "
                  >Please enter valid text.</mat-error
                >
              </mat-form-field>
            </div>
          </div>
        </div>
        <div
          class="col-xs-6 col-sm-6 col-md-6 col-lg-6"
          [ngClass]="{
            'has-error': formdata
              .get('outputconstraintsCtr')
              .hasError('invalid')
          }"
        >
          <div class="row">
            <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">
              <mat-label class="label-input"
                >Output Constraints
                <span class="iep-required">*</span></mat-label
              >
            </div>
            <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">
              <mat-form-field>
                <input
                  matInput
                  formControlName="outputconstraintsCtr"
                  placeholder=""
                  name="outputconstraints"
                  [(ngModel)]="process.outputConstraint"
                />
                <mat-error
                  *ngIf="
                    formdata.get('outputconstraintsCtr').hasError('maxlength')
                  "
                  class="help-block"
                  >outputConstraints is too long.</mat-error
                >
                <mat-error
                  *ngIf="
                    formdata.get('outputconstraintsCtr').hasError('whitespace')
                  "
                  >Please enter valid text.</mat-error
                >
              </mat-form-field>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3">
          <mat-label class="label-input"
            >Workflow Type <span class="iep-required">*</span></mat-label
          >
        </div>
        <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3">
          <mat-form-field>
            <mat-select
              [(ngModel)]="process.workflowType"
              formControlName="workflowTypeCtr"
            >
              <mat-option value="">-- Select --</mat-option>
              <mat-option
                *ngFor="let wtype of processWorkflow"
                value="{{ wtype.type }}"
                >{{ wtype.type }}</mat-option
              >
            </mat-select>
          </mat-form-field>
        </div>
      </div>
    </fieldset>

    <!-- Choose Load -->
    <div class="row">
      <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3">
        <mat-label class="label-input"
          >Choose Load <span class="iep-required">*</span></mat-label
        >
      </div>
      <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">
        <mat-form-field>
          <mat-select
            [(ngModel)]="process.loadId"
            formControlName="loadRIdCtr"
            [disabled]="
              createNewProcess === undefined || createNewProcess === ''
            "
          >
            <mat-option value="">-- Select --</mat-option>
            <mat-option
              *ngFor="let load of loadDataOfSites"
              value="{{ load.loadId }}"
              >{{ load.name }} ---- {{ load.loadId }}</mat-option
            >
          </mat-select>
        </mat-form-field>
      </div>
    </div>

    <!-- Add Process -->
    <div class="row">
      <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3"></div>
      <div class="col-xs-9 col-sm-9 col-md-9 col-lg-9">
        <button
          type="submit"
          id="addProcessbtn"
          class="btn btn-warning"
          (click)="insertProcessMaster()"
          [disabled]="!isFormValid()"
        >
          <span class="glyphicon glyphicon-plus"></span>Add Process
        </button>
      </div>
    </div>
  </form>

  <mat-expansion-panel
    class="md-expansion-demo-width"
    #processPanel
    expanded="true"
  >
    <mat-expansion-panel-header>
      <mat-panel-title><h6>Energy Process Flow</h6></mat-panel-title>
    </mat-expansion-panel-header>
    <div class="row">
      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
        <table #processtable class="table">
          <caption></caption>
          <thead>
            <tr>
              <th scope="col">Process</th>
              <th scope="col">Load</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let processItem of processes">
              <td>{{ processItem.name }}</td>
              <td>
                <div *ngFor="let load of processItem.loads">
                  {{ load.name }}
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </mat-expansion-panel>

  <mat-action-row>
    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 text-center">
      <button
        (click)="previousStep($event)"
        id="previousbtn"
        bciprimarybutton
        class="button-primary"
      >
        <span>
          <mat-icon
            aria-hidden="false"
            aria-label="weather icon"
            class="bosch-ic-arrow-left-frame"
            style="width: max-content"
          ></mat-icon> </span
        >Previous
      </button>
      <button
        type="submit"
        bciprimarybutton
        class="button-primary"
        id="submitbtn"
        style="margin-left: 3px"
        [disabled]="!isFormValid()"
      >
        <span>
          <mat-icon
            aria-hidden="false"
            aria-label="weather icon"
            class="bosch-ic-checkmark-frame"
            style="width: max-content"
          ></mat-icon> </span
        >Submit
      </button>

      <button
        (click)="nextStep($event)"
        bciprimarybutton
        class="button-primary"
        id="nextbtn"
        style="margin-left: 3px"
      >
        Next
        <span>
          <mat-icon
            aria-hidden="false"
            aria-label="weather icon"
            class="bosch-ic-arrow-right-frame"
            style="width: max-content"
          ></mat-icon>
        </span>
      </button>
    </div>
  </mat-action-row>
</mat-expansion-panel>

<!-- Water Process Flow Details -->
<mat-expansion-panel
  class="md-expansion-demo-width"
  #myWaterPanel
  expanded="false"
  [disabled]="waterUtility"
>
  <mat-expansion-panel-header>
    <mat-panel-title>
      <div class="col-md-6">
        <h6>Water Process Flow Details</h6>
      </div>
      <div class="col-md-6" *ngIf="siteId !== '' && siteId !== 'default'">
        <h6>Site Id: {{ siteId }}</h6>
      </div>
    </mat-panel-title>
  </mat-expansion-panel-header>

  <form [formGroup]="formdataWater" #formDirective="ngForm" novalidate>
    <div class="row">
      <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">
        <div class="row">
          <div class="col-lg-6">
            <mat-label class="label-input"
              >Create New Process <span class="iep-required">*</span></mat-label
            >
          </div>
          <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">
            <mat-form-field>
              <mat-select
                [(ngModel)]="createNewWaterProcess"
                (selectionChange)="onCreateNewWaterProcessSelectionChanged()"
                formControlName="createNewWaterProcessCtr"
              >
                <mat-option value="">-- Yes / No --</mat-option>
                <mat-option value="true">Yes</mat-option>
                <mat-option value="false">No</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
      </div>

      <!-- column Process -->
      <div
        class="col-xs-6 col-sm-6 col-md-6 col-lg-6"
        *ngIf="createNewWaterProcess === 'false'"
      >
        <div class="row">
          <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">
            <mat-label class="label-input">Process</mat-label>
          </div>
          <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">
            <mat-form-field>
              <mat-select
                [(ngModel)]="processWater.processId"
                formControlName="processWaterCtr"
              >
                <mat-option value="">-- choose Process --</mat-option>
                <mat-option
                  *ngFor="let processItem of processesWater"
                  value="{{ processItem.processId }}"
                >
                  {{ processItem.name }}</mat-option
                >
              </mat-select>
            </mat-form-field>
          </div>
        </div>
      </div>
      <div
        class="col-xs-6 col-sm-6 col-md-6 col-lg-6"
        *ngIf="createNewWaterProcess === 'true'"
      >
        <div class="row">
          <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">
            <mat-label class="label-input"
              >Process Name <span class="iep-required">*</span>
            </mat-label>
          </div>
          <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">
            <mat-form-field>
              <input
                matInput
                formControlName="processWaternameCtr"
                id="processWaternameCtr"
                [(ngModel)]="processWater.processName"
                (focusout)="onWaterProcessNameFocusOut()"
                required
              />
              <mat-error
                *ngIf="
                  formdataWater.get('processWaternameCtr').hasError('required')
                "
                >This field is required.
              </mat-error>
              <mat-error
                *ngIf="
                  formdataWater
                    .get('processWaternameCtr')
                    .hasError('duplicated')
                "
                >Duplicated Process Name.</mat-error
              >
              <mat-error
                *ngIf="
                  formdataWater.get('processWaternameCtr').hasError('maxlength')
                "
              >
                Please provide name up to 50 Characters.
              </mat-error>
              <mat-error
                *ngIf="
                  formdataWater.get('processWaternameCtr').hasError('pattern')
                "
              >
                Only (& . - _ / : ,) special symbol allowed.
              </mat-error>
              <mat-error
                *ngIf="
                  formdataWater
                    .get('processWaternameCtr')
                    .hasError('whitespace')
                "
                >Please enter valid text.</mat-error
              >
            </mat-form-field>
          </div>
        </div>
      </div>
    </div>

    <fieldset *ngIf="createNewWaterProcess === 'true'">
      <legend></legend>
      <div class="row">
        <div
          class="col-xs-6 col-sm-6 col-md-6 col-lg-6"
          [ngClass]="{
            'has-error':
              formdataWater
                .get('inputconstraintsWaterCtr')
                .hasError('maxlength') === true
          }"
        >
          <div class="row">
            <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">
              <mat-label class="label-input"
                >Input Constraints
                <span class="iep-required">*</span></mat-label
              >
            </div>
            <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">
              <mat-form-field>
                <input
                  matInput
                  formControlName="inputconstraintsWaterCtr"
                  placeholder=""
                  [(ngModel)]="processWater.inputConstraint"
                />
                <mat-error
                  *ngIf="
                    formdataWater
                      .get('inputconstraintsWaterCtr')
                      .hasError('maxlength')
                  "
                  class="help-block"
                  >inputConstraints is too long.</mat-error
                >
                <mat-error
                  *ngIf="
                    formdataWater
                      .get('inputconstraintsWaterCtr')
                      .hasError('whitespace')
                  "
                  >Please enter valid text.</mat-error
                >
              </mat-form-field>
            </div>
          </div>
        </div>
        <div
          class="col-xs-6 col-sm-6 col-md-6 col-lg-6"
          [ngClass]="{
            'has-error': formdataWater
              .get('outputconstraintsWaterCtr')
              .hasError('invalid')
          }"
        >
          <div class="row">
            <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">
              <mat-label class="label-input"
                >Output Constraints
                <span class="iep-required">*</span></mat-label
              >
            </div>
            <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">
              <mat-form-field>
                <input
                  matInput
                  formControlName="outputconstraintsWaterCtr"
                  placeholder=""
                  name="outputconstraints"
                  [(ngModel)]="process.outputConstraint"
                />
                <mat-error
                  *ngIf="
                    formdataWater
                      .get('outputconstraintsWaterCtr')
                      .hasError('maxlength')
                  "
                  class="help-block"
                  >outputConstraints is too long.</mat-error
                >
                <mat-error
                  *ngIf="
                    formdataWater
                      .get('outputconstraintsWaterCtr')
                      .hasError('whitespace')
                  "
                  >Please enter valid text.</mat-error
                >
              </mat-form-field>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3">
          <mat-label class="label-input"
            >Workflow Type <span class="iep-required">*</span></mat-label
          >
        </div>
        <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3">
          <mat-form-field>
            <mat-select
              [(ngModel)]="processWater.workflowType"
              formControlName="workflowTypeWaterCtr"
            >
              <mat-option value="">-- Select --</mat-option>
              <mat-option
                *ngFor="let wtype of processWaterWorkflow"
                value="{{ wtype.type }}"
                >{{ wtype.type }}</mat-option
              >
            </mat-select>
          </mat-form-field>
        </div>
      </div>
    </fieldset>

    <!-- Choose Load -->
    <div class="row">
      <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3">
        <mat-label class="label-input"
          >Choose Load <span class="iep-required">*</span></mat-label
        >
      </div>
      <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">
        <mat-form-field>
          <mat-select
            [(ngModel)]="processWater.loadId"
            formControlName="loadRIdWaterCtr"
            [disabled]="
              createNewWaterProcess === undefined ||
              createNewWaterProcess === ''
            "
          >
            <mat-option value="">-- Select --</mat-option>
            <mat-option
              *ngFor="let load of loadWaterDataOfSites"
              value="{{ load.loadId }}"
              >{{ load.name }} ---- {{ load.loadId }}</mat-option
            >
          </mat-select>
        </mat-form-field>
      </div>
    </div>

    <!-- Add Process -->
    <div class="row">
      <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3"></div>
      <div class="col-xs-9 col-sm-9 col-md-9 col-lg-9">
        <button
          type="submit"
          id="addWaterProcessbtn"
          class="btn btn-warning"
          (click)="insertWaterProcessMaster()"
          [disabled]="!isWaterFormValid()"
        >
          <span class="glyphicon glyphicon-plus"></span>Add Process
        </button>
      </div>
    </div>
  </form>

  <mat-expansion-panel
    class="md-expansion-demo-width"
    #processPanel
    expanded="true"
  >
    <mat-expansion-panel-header>
      <mat-panel-title>
        <h6>Water Process Flow</h6>
      </mat-panel-title>
    </mat-expansion-panel-header>
    <div class="row">
      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
        <table #processtable class="table">
          <caption></caption>
          <thead>
            <tr>
              <th scope="col">Process</th>
              <th scope="col">Load</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let processItem of processesWater">
              <td>{{ processItem.name }}</td>
              <td>
                <div *ngFor="let load of processItem.loads">
                  {{ load.name }}
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </mat-expansion-panel>

  <mat-action-row>
    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 text-center">
      <button
        (click)="previousStep($event)"
        id="previousbtn"
        bciprimarybutton
        class="button-primary"
      >
        <span>
          <mat-icon
            aria-hidden="false"
            aria-label="weather icon"
            class="bosch-ic-arrow-left-frame"
            style="width: max-content"
          ></mat-icon> </span
        >Previous
      </button>
      <button
        type="submit"
        bciprimarybutton
        class="button-primary"
        id="submitbtn"
        style="margin-left: 3px"
        [disabled]="!isWaterFormValid()"
      >
        <span>
          <mat-icon
            aria-hidden="false"
            aria-label="weather icon"
            class="bosch-ic-checkmark-frame"
            style="width: max-content"
          ></mat-icon> </span
        >Submit
      </button>

      <button
        (click)="nextStep($event)"
        bciprimarybutton
        class="button-primary"
        id="nextbtn"
        style="margin-left: 3px"
      >
        Next
        <span>
          <mat-icon
            aria-hidden="false"
            aria-label="weather icon"
            class="bosch-ic-arrow-right-frame"
            style="width: max-content"
          ></mat-icon>
        </span>
      </button>
    </div>
  </mat-action-row>
</mat-expansion-panel>

<!-- Gas Process Flow Details -->
<mat-expansion-panel
  class="md-expansion-demo-width"
  #myGasPanel
  expanded="false"
  [disabled]="gasUtility"
>
  <mat-expansion-panel-header>
    <mat-panel-title>
      <div class="col-md-6">
        <h6>Gas Process Flow Details</h6>
      </div>
      <div class="col-md-6" *ngIf="siteId !== '' && siteId !== 'default'">
        <h6>Site Id: {{ siteId }}</h6>
      </div>
    </mat-panel-title>
  </mat-expansion-panel-header>

  <form [formGroup]="formdataGas" #formDirective="ngForm" novalidate>
    <div class="row">
      <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">
        <div class="row">
          <div class="col-lg-6">
            <mat-label class="label-input"
              >Create New Process <span class="iep-required">*</span></mat-label
            >
          </div>
          <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">
            <mat-form-field>
              <mat-select
                [(ngModel)]="createNewGasProcess"
                (selectionChange)="onCreateNewGasProcessSelectionChanged()"
                formControlName="createNewGasProcessCtr"
              >
                <mat-option value="">-- Yes / No --</mat-option>
                <mat-option value="true">Yes</mat-option>
                <mat-option value="false">No</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
      </div>

      <!-- column Process -->
      <div
        class="col-xs-6 col-sm-6 col-md-6 col-lg-6"
        *ngIf="createNewGasProcess === 'false'"
      >
        <div class="row">
          <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">
            <mat-label class="label-input">Process</mat-label>
          </div>
          <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">
            <mat-form-field>
              <mat-select
                [(ngModel)]="processGas.processId"
                formControlName="processGasCtr"
              >
                <mat-option value="">-- choose Process --</mat-option>
                <mat-option
                  *ngFor="let processItem of processesGas"
                  value="{{ processItem.processId }}"
                >
                  {{ processItem.name }}</mat-option
                >
              </mat-select>
            </mat-form-field>
          </div>
        </div>
      </div>
      <div
        class="col-xs-6 col-sm-6 col-md-6 col-lg-6"
        *ngIf="createNewGasProcess === 'true'"
      >
        <div class="row">
          <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">
            <mat-label class="label-input"
              >Process Name <span class="iep-required">*</span>
            </mat-label>
          </div>
          <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">
            <mat-form-field>
              <input
                matInput
                formControlName="processGasnameCtr"
                id="processGasnameCtr"
                [(ngModel)]="processGas.processName"
                (focusout)="onGasProcessNameFocusOut()"
                required
              />
              <mat-error
                *ngIf="
                  formdataGas.get('processGasnameCtr').hasError('required')
                "
                >This field is required.
              </mat-error>
              <mat-error
                *ngIf="
                  formdataGas.get('processGasnameCtr').hasError('duplicated')
                "
                >Duplicated Process Name.</mat-error
              >
              <mat-error
                *ngIf="
                  formdataGas.get('processGasnameCtr').hasError('maxlength')
                "
              >
                Please provide name up to 50 Characters.
              </mat-error>
              <mat-error
                *ngIf="formdataGas.get('processGasnameCtr').hasError('pattern')"
              >
                Only (& . - _ / : ,) special symbol allowed.
              </mat-error>
              <mat-error
                *ngIf="
                  formdataGas.get('processGasnameCtr').hasError('whitespace')
                "
                >Please enter valid text.</mat-error
              >
            </mat-form-field>
          </div>
        </div>
      </div>
    </div>

    <fieldset *ngIf="createNewGasProcess === 'true'">
      <legend></legend>
      <div class="row">
        <div
          class="col-xs-6 col-sm-6 col-md-6 col-lg-6"
          [ngClass]="{
            'has-error':
              formdataGas
                .get('inputconstraintsGasCtr')
                .hasError('maxlength') === true
          }"
        >
          <div class="row">
            <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">
              <mat-label class="label-input"
                >Input Constraints
                <span class="iep-required">*</span></mat-label
              >
            </div>
            <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">
              <mat-form-field>
                <input
                  matInput
                  formControlName="inputconstraintsGasCtr"
                  placeholder=""
                  [(ngModel)]="processGas.inputConstraint"
                />
                <mat-error
                  *ngIf="
                    formdataGas
                      .get('inputconstraintsGasCtr')
                      .hasError('maxlength')
                  "
                  class="help-block"
                  >inputConstraints is too long.</mat-error
                >
                <mat-error
                  *ngIf="
                    formdataGas
                      .get('inputconstraintsGasCtr')
                      .hasError('whitespace')
                  "
                  >Please enter valid text.</mat-error
                >
              </mat-form-field>
            </div>
          </div>
        </div>
        <div
          class="col-xs-6 col-sm-6 col-md-6 col-lg-6"
          [ngClass]="{
            'has-error': formdataGas
              .get('outputconstraintsGasCtr')
              .hasError('invalid')
          }"
        >
          <div class="row">
            <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">
              <mat-label class="label-input"
                >Output Constraints
                <span class="iep-required">*</span></mat-label
              >
            </div>
            <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">
              <mat-form-field>
                <input
                  matInput
                  formControlName="outputconstraintsGasCtr"
                  placeholder=""
                  name="outputconstraints"
                  [(ngModel)]="process.outputConstraint"
                />
                <mat-error
                  *ngIf="
                    formdataGas
                      .get('outputconstraintsGasCtr')
                      .hasError('maxlength')
                  "
                  class="help-block"
                  >outputConstraints is too long.</mat-error
                >
                <mat-error
                  *ngIf="
                    formdataGas
                      .get('outputconstraintsGasCtr')
                      .hasError('whitespace')
                  "
                  >Please enter valid text.</mat-error
                >
              </mat-form-field>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3">
          <mat-label class="label-input"
            >Workflow Type <span class="iep-required">*</span></mat-label
          >
        </div>
        <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3">
          <mat-form-field>
            <mat-select
              [(ngModel)]="processGas.workflowType"
              formControlName="workflowTypeGasCtr"
            >
              <mat-option value="">-- Select --</mat-option>
              <mat-option
                *ngFor="let wtype of processGasWorkflow"
                value="{{ wtype.type }}"
                >{{ wtype.type }}</mat-option
              >
            </mat-select>
          </mat-form-field>
        </div>
      </div>
    </fieldset>

    <!-- Choose Load -->
    <div class="row">
      <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3">
        <mat-label class="label-input"
          >Choose Load <span class="iep-required">*</span></mat-label
        >
      </div>
      <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">
        <mat-form-field>
          <mat-select
            [(ngModel)]="processGas.loadId"
            formControlName="loadRIdGasCtr"
            [disabled]="
              createNewGasProcess === undefined || createNewGasProcess === ''
            "
          >
            <mat-option value="">-- Select --</mat-option>
            <mat-option
              *ngFor="let load of loadGasDataOfSites"
              value="{{ load.loadId }}"
              >{{ load.name }} ---- {{ load.loadId }}</mat-option
            >
          </mat-select>
        </mat-form-field>
      </div>
    </div>

    <!-- Add Process -->
    <div class="row">
      <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3"></div>
      <div class="col-xs-9 col-sm-9 col-md-9 col-lg-9">
        <button
          type="submit"
          id="addGasProcessbtn"
          class="btn btn-warning"
          (click)="insertGasProcessMaster()"
          [disabled]="!isGasFormValid()"
        >
          <span class="glyphicon glyphicon-plus"></span>Add Process
        </button>
      </div>
    </div>
  </form>

  <mat-expansion-panel
    class="md-expansion-demo-width"
    #processPanel
    expanded="true"
  >
    <mat-expansion-panel-header>
      <mat-panel-title>
        <h6>Gas Process Flow</h6>
      </mat-panel-title>
    </mat-expansion-panel-header>
    <div class="row">
      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
        <table #processtable class="table">
          <caption></caption>
          <thead>
            <tr>
              <th scope="col">Process</th>
              <th scope="col">Load</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let processItem of processesGas">
              <td>{{ processItem.name }}</td>
              <td>
                <div *ngFor="let load of processItem.loads">
                  {{ load.name }}
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </mat-expansion-panel>

  <mat-action-row>
    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 text-center">
      <button
        (click)="previousStep($event)"
        id="previousbtn"
        bciprimarybutton
        class="button-primary"
      >
        <span>
          <mat-icon
            aria-hidden="false"
            aria-label="weather icon"
            class="bosch-ic-arrow-left-frame"
            style="width: max-content"
          ></mat-icon> </span
        >Previous
      </button>
      <button
        type="submit"
        bciprimarybutton
        class="button-primary"
        id="submitbtn"
        style="margin-left: 3px"
        [disabled]="!isGasFormValid()"
      >
        <span>
          <mat-icon
            aria-hidden="false"
            aria-label="weather icon"
            class="bosch-ic-checkmark-frame"
            style="width: max-content"
          ></mat-icon> </span
        >Submit
      </button>

      <button
        (click)="nextStep($event)"
        bciprimarybutton
        class="button-primary"
        id="nextbtn"
        style="margin-left: 3px"
      >
        Next
        <span>
          <mat-icon
            aria-hidden="false"
            aria-label="weather icon"
            class="bosch-ic-arrow-right-frame"
            style="width: max-content"
          ></mat-icon>
        </span>
      </button>
    </div>
  </mat-action-row>
</mat-expansion-panel>

<!-- Air Process Flow Details -->
<mat-expansion-panel
  class="md-expansion-demo-width"
  #myAirPanel
  expanded="false"
  [disabled]="airUtility"
>
  <mat-expansion-panel-header>
    <mat-panel-title>
      <div class="col-md-6">
        <h6>Air Process Flow Details</h6>
      </div>
      <div class="col-md-6" *ngIf="siteId !== '' && siteId !== 'default'">
        <h6>Site Id: {{ siteId }}</h6>
      </div>
    </mat-panel-title>
  </mat-expansion-panel-header>

  <form [formGroup]="formdataAir" #formDirective="ngForm" novalidate>
    <div class="row">
      <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">
        <div class="row">
          <div class="col-lg-6">
            <mat-label class="label-input"
              >Create New Process <span class="iep-required">*</span></mat-label
            >
          </div>
          <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">
            <mat-form-field>
              <mat-select
                [(ngModel)]="createNewAirProcess"
                (selectionChange)="onCreateNewAirProcessSelectionChanged()"
                formControlName="createNewAirProcessCtr"
              >
                <mat-option value="">-- Yes / No --</mat-option>
                <mat-option value="true">Yes</mat-option>
                <mat-option value="false">No</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
      </div>

      <!-- column Process -->
      <div
        class="col-xs-6 col-sm-6 col-md-6 col-lg-6"
        *ngIf="createNewAirProcess === 'false'"
      >
        <div class="row">
          <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">
            <mat-label class="label-input">Process</mat-label>
          </div>
          <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">
            <mat-form-field>
              <mat-select
                [(ngModel)]="processAir.processId"
                formControlName="processAirCtr"
              >
                <mat-option value="">-- choose Process --</mat-option>
                <mat-option
                  *ngFor="let processItem of processesAir"
                  value="{{ processItem.processId }}"
                >
                  {{ processItem.name }}</mat-option
                >
              </mat-select>
            </mat-form-field>
          </div>
        </div>
      </div>
      <div
        class="col-xs-6 col-sm-6 col-md-6 col-lg-6"
        *ngIf="createNewAirProcess === 'true'"
      >
        <div class="row">
          <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">
            <mat-label class="label-input"
              >Process Name <span class="iep-required">*</span>
            </mat-label>
          </div>
          <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">
            <mat-form-field>
              <input
                matInput
                formControlName="processAirnameCtr"
                id="processAirnameCtr"
                [(ngModel)]="processAir.processName"
                (focusout)="onAirProcessNameFocusOut()"
                required
              />
              <mat-error
                *ngIf="
                  formdataAir.get('processAirnameCtr').hasError('required')
                "
                >This field is required.
              </mat-error>
              <mat-error
                *ngIf="
                  formdataAir.get('processAirnameCtr').hasError('duplicated')
                "
                >Duplicated Process Name.</mat-error
              >
              <mat-error
                *ngIf="
                  formdataAir.get('processAirnameCtr').hasError('maxlength')
                "
              >
                Please provide name up to 50 Characters.
              </mat-error>
              <mat-error
                *ngIf="formdataAir.get('processAirnameCtr').hasError('pattern')"
              >
                Only (& . - _ / : ,) special symbol allowed.
              </mat-error>
              <mat-error
                *ngIf="
                  formdataAir.get('processAirnameCtr').hasError('whitespace')
                "
                >Please enter valid text.</mat-error
              >
            </mat-form-field>
          </div>
        </div>
      </div>
    </div>

    <fieldset *ngIf="createNewAirProcess === 'true'">
      <legend></legend>
      <div class="row">
        <div
          class="col-xs-6 col-sm-6 col-md-6 col-lg-6"
          [ngClass]="{
            'has-error':
              formdataAir
                .get('inputconstraintsAirCtr')
                .hasError('maxlength') === true
          }"
        >
          <div class="row">
            <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">
              <mat-label class="label-input"
                >Input Constraints
                <span class="iep-required">*</span></mat-label
              >
            </div>
            <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">
              <mat-form-field>
                <input
                  matInput
                  formControlName="inputconstraintsAirCtr"
                  placeholder=""
                  [(ngModel)]="processAir.inputConstraint"
                />
                <mat-error
                  *ngIf="
                    formdataAir
                      .get('inputconstraintsAirCtr')
                      .hasError('maxlength')
                  "
                  class="help-block"
                  >inputConstraints is too long.</mat-error
                >
                <mat-error
                  *ngIf="
                    formdataAir
                      .get('inputconstraintsAirCtr')
                      .hasError('whitespace')
                  "
                  >Please enter valid text.</mat-error
                >
              </mat-form-field>
            </div>
          </div>
        </div>
        <div
          class="col-xs-6 col-sm-6 col-md-6 col-lg-6"
          [ngClass]="{
            'has-error': formdataAir
              .get('outputconstraintsAirCtr')
              .hasError('invalid')
          }"
        >
          <div class="row">
            <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">
              <mat-label class="label-input"
                >Output Constraints
                <span class="iep-required">*</span></mat-label
              >
            </div>
            <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">
              <mat-form-field>
                <input
                  matInput
                  formControlName="outputconstraintsAirCtr"
                  placeholder=""
                  name="outputconstraints"
                  [(ngModel)]="process.outputConstraint"
                />
                <mat-error
                  *ngIf="
                    formdataAir
                      .get('outputconstraintsAirCtr')
                      .hasError('maxlength')
                  "
                  class="help-block"
                  >outputConstraints is too long.</mat-error
                >
                <mat-error
                  *ngIf="
                    formdataAir
                      .get('outputconstraintsAirCtr')
                      .hasError('whitespace')
                  "
                  >Please enter valid text.</mat-error
                >
              </mat-form-field>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3">
          <mat-label class="label-input"
            >Workflow Type <span class="iep-required">*</span></mat-label
          >
        </div>
        <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3">
          <mat-form-field>
            <mat-select
              [(ngModel)]="processAir.workflowType"
              formControlName="workflowTypeAirCtr"
            >
              <mat-option value="">-- Select --</mat-option>
              <mat-option
                *ngFor="let wtype of processAirWorkflow"
                value="{{ wtype.type }}"
                >{{ wtype.type }}</mat-option
              >
            </mat-select>
          </mat-form-field>
        </div>
      </div>
    </fieldset>

    <!-- Choose Load -->
    <div class="row">
      <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3">
        <mat-label class="label-input"
          >Choose Load <span class="iep-required">*</span></mat-label
        >
      </div>
      <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">
        <mat-form-field>
          <mat-select
            [(ngModel)]="processAir.loadId"
            formControlName="loadRIdAirCtr"
            [disabled]="
              createNewAirProcess === undefined || createNewAirProcess === ''
            "
          >
            <mat-option value="">-- Select --</mat-option>
            <mat-option
              *ngFor="let load of loadAirDataOfSites"
              value="{{ load.loadId }}"
              >{{ load.name }} ---- {{ load.loadId }}</mat-option
            >
          </mat-select>
        </mat-form-field>
      </div>
    </div>

    <!-- Add Process -->
    <div class="row">
      <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3"></div>
      <div class="col-xs-9 col-sm-9 col-md-9 col-lg-9">
        <button
          type="submit"
          id="addAirProcessbtn"
          class="btn btn-warning"
          (click)="insertAirProcessMaster()"
          [disabled]="!isAirFormValid()"
        >
          <span class="glyphicon glyphicon-plus"></span>Add Process
        </button>
      </div>
    </div>
  </form>

  <mat-expansion-panel
    class="md-expansion-demo-width"
    #processPanel
    expanded="true"
  >
    <mat-expansion-panel-header>
      <mat-panel-title>
        <h6>Air Process Flow</h6>
      </mat-panel-title>
    </mat-expansion-panel-header>
    <div class="row">
      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
        <table #processtable class="table">
          <caption></caption>
          <thead>
            <tr>
              <th scope="col">Process</th>
              <th scope="col">Load</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let processItem of processesGas">
              <td>{{ processItem.name }}</td>
              <td>
                <div *ngFor="let load of processItem.loads">
                  {{ load.name }}
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </mat-expansion-panel>

  <mat-action-row>
    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 text-center">
      <button
        (click)="previousStep($event)"
        id="previousbtn"
        bciprimarybutton
        class="button-primary"
      >
        <span>
          <mat-icon
            aria-hidden="false"
            aria-label="weather icon"
            class="bosch-ic-arrow-left-frame"
            style="width: max-content"
          ></mat-icon> </span
        >Previous
      </button>
      <button
        type="submit"
        bciprimarybutton
        class="button-primary"
        id="submitbtn"
        style="margin-left: 3px"
        [disabled]="!isAirFormValid()"
      >
        <span>
          <mat-icon
            aria-hidden="false"
            aria-label="weather icon"
            class="bosch-ic-checkmark-frame"
            style="width: max-content"
          ></mat-icon> </span
        >Submit
      </button>

      <button
        (click)="nextStep($event)"
        bciprimarybutton
        class="button-primary"
        id="nextbtn"
        style="margin-left: 3px"
      >
        Next
        <span>
          <mat-icon
            aria-hidden="false"
            aria-label="weather icon"
            class="bosch-ic-arrow-right-frame"
            style="width: max-content"
          ></mat-icon>
        </span>
      </button>
    </div>
  </mat-action-row>
</mat-expansion-panel>
